import { Col, Row } from "antd";
import React, { useEffect, useReducer, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { initialState, reducer } from "./reducer";
import { isValidValue } from "../../helpers/FormHelper";
import { getErrorMessage } from "../../helpers/ErrorHelper";
import Search from "./components/Search";
import VHPService from "../../services/VHP/VHPService";
import SimpleHeader from "../../helpers/cards-helper/SimpleHeader";
import List from "./components/List";
import PatronagerService from "../../services/Election/Patronage/PatronagerService";
import Edit from "./components/Edit";
// import Edit from "./components/Edit";



const MyVHPVoters = () => {
    const token = useSelector((state) => state.Member.token);
    const [state, dispatch] = useReducer(reducer, initialState);
    const [errorMessage, setErrorMessage] = useState(null);
    const loadingTypeReference = useRef(null);


    useEffect(() => {
        const fetchReferences = async () => {
            try {
                updateLoading(true);
                const response = await VHPService.getMyVoters(token, state.filters);
                const responseData = response.data;
                if (responseData) {
                    updateItems(responseData?.data, responseData?.count);
                    setErrorMessage(null);
                } else {
                    setErrorMessage('Një gabim ndodhi gjatë komunikimit me serverin!');
                    updateItems([], 0);
                }
            } catch (error) {
                const errorMessage = getErrorMessage(error);
                setErrorMessage(errorMessage);
                updateItems([], 0);
            } finally {
                updateLoading(false);
            }
        };

        fetchReferences();
    }, [token, state.filters]);


    useEffect(() => {
        const fetchPreferences = async () => {
            try {
                const response = await PatronagerService.getPoliticalPreferencesList(token);
                const responseData = response.data;
                const preferenceItems = isValidValue(responseData) ? responseData : [];
                dispatch({ type: 'set_preferences', payload: preferenceItems });
            } catch (error) {
                dispatch({ type: 'set_preferences', payload: [] });
            }
        };

        fetchPreferences();
    }, [token]);


    const updateItems = (itemsList, itemsCount) => {
        const action = {
            type: "set_items",
            payload: {
                items: itemsList,
                total: itemsCount,
            },
        };
        dispatch(action);
    };


    const updateLoading = (isLoading) => {
        const loadingType = loadingTypeReference.current;
        const action = {
            type: isValidValue(loadingType) ? `set_${loadingType}_loading` : 'set_loading',
            payload: isLoading,
        };
        dispatch(action);
    };


    const updateIndexVisibility = (index) => {
        const action = {
            type: "set_index_visibility",
            payload: index,
        };
        dispatch(action);
    };


    const onRefresh = () => {
        dispatch({ type: "refresh_list" });
    };


    const onSuccess = () => {
        updateIndexVisibility(0);
        onRefresh();
    };


    return (
        <Row gutter={24} className="page-content">
            <Col span={24}>

                {state.indexVisibility === 0 && (
                    <Row gutter={24}>
                        <Col span={24}>

                            <Row gutter={24} className="mb-3">
                                <Col span={24}>
                                    <SimpleHeader
                                        title="Lista e votuesve për herë të parë"
                                        subtitle="Lista e votuesve për herë të parë"
                                    />
                                </Col>
                            </Row>
                            <Row gutter={24} className="mb-3">
                                <Col span={24}>
                                    <Search
                                        dispatch={dispatch}
                                        preferences={state.preferences}
                                        initialFilters={state.filters.searchFilters}
                                        clearLoading={state.clearLoading}
                                        searchLoading={state.searchLoading}
                                        setLoadingType={(loadingType) => { loadingTypeReference.current = loadingType }}
                                    />
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={24}>
                                    <List
                                        dispatch={dispatch}
                                        items={state.items}
                                        totalCount={state.totalCount}
                                        initialPagination={state.filters.pagination}
                                        loading={state.loading}
                                        errorMessage={errorMessage}
                                        onSuccess={onSuccess}
                                        setLoadingType={(loadingType) => { loadingTypeReference.current = loadingType }}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 1 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <Edit
                                item={state.itemSelected}
                                countries={state.countries}
                                preferences={state.preferences}
                                referenceTypes={state.referenceTypes}
                                onBack={() => updateIndexVisibility(0)}
                                onSuccess={onSuccess}
                            />
                        </Col>
                    </Row>
                )}

            </Col>
        </Row>
    );
};

export default MyVHPVoters;